import { createContext } from 'react';
import { HeaderBlokProps } from '../components/Header/Header';
import { FooterBlokProps } from '../components/Footer/Footer';
import { ContactBarBlokProps } from '../components/ContactBar/ContactBar';
import { StoryblokNode } from '../interfaces/StoryblokNode.interface';
import { Breadcrumbs } from '../interfaces/Breadcrumbs.interface';
import { SharePageBarBlokProps } from '../components/SharePageBar/SharePageBar';

interface LayoutContextProps {
  header: StoryblokNode<HeaderBlokProps> | null;
  footer: StoryblokNode<FooterBlokProps> | null;
  contact_bar: StoryblokNode<ContactBarBlokProps> | null;
  breadcrumbs: Breadcrumbs | null;
  share_page_bar: StoryblokNode<SharePageBarBlokProps> | null;
}

export const LayoutContext = createContext<LayoutContextProps>({
  header: null,
  footer: null,
  contact_bar: null,
  breadcrumbs: null,
  share_page_bar: null,
});
